import { ref } from "vue";
import Global from "../Global";
import { ResultCodeEnum } from "../SuperEnum";
import Tools from "../Tools";

/**
 * HTTP返回值
 */
export default class HttpResponse<T = any> {
     Code?: ResultCodeEnum;
     Data?: T;
     Message?: string;
     Success?: boolean;
     /**
      * 检查是否成功
      * @param showErrorMessage 
      */
     public CheckIsOk(showErrorMessage: boolean = true): boolean {
          if (this.Success) {
               return true;
          }
          else {
               if (showErrorMessage)
                    Tools.AlertError(this.Message ?? '未知错误!');
               switch (this.Code) {
                    case ResultCodeEnum.UnAuthorized: //未登录
                         Global.JwtToken = ref('');
                         Global.RefreshToken = ref('');
                         Global.mqttService.CloseAsync();
                         Tools.GoTo("/", true);
                         
                         break;
               }

               return false;
          }
     }
}